import Text from './Text';

export type { TTextProps } from './Text';
export { isText } from './Text';

export default Text;
